<vs-dialog [config]="{ dialogContainerClass: 'w-[350px] sm:w-[700px] lg:w-[900px] max-w-[95vw]' }">
  <vs-dialog-header
    [config]="{
      mode: 'simple',
      showDivider: true,

      icon: 'receipt',
      iconTheme: 'primary',

      title: config.title,
      subtitle: config.subtitle
    }"
  ></vs-dialog-header>

  <div *ngIf="item as item" class="px-2 pt-4 flex flex-col gap-4">
    <div class="rounded-xl border border-gray-200 bg-gray-50 shadow-sm overflow-hidden">
      <div class="flex flex-col gap-2 px-4 py-3 text-sm">
        <div class="flex justify-between gap-4">
          <span class="text-gray-600">{{ config.date }}</span>
          <span class="font-medium text-gray-900"
            >{{ (item.transactionDate ?? item.created) | date: 'mediumDate' }}</span
          >
        </div>

        <div class="flex justify-between gap-4">
          <span class="text-gray-600 shrink-0">{{ config.referenceNumber }}</span>
          <span class="font-medium text-gray-900 break-all text-right">{{ item.referenceNumber ?? '—' }}</span>
        </div>

        <div class="flex justify-between gap-4">
          <span class="text-gray-600">{{ config.paymentMethod }}</span>
          <span class="font-medium text-gray-900">{{ item.paymentMethod ?? '—' }}</span>
        </div>

        <div class="flex justify-between gap-4">
          <span class="text-gray-600">{{ config.status }}</span>
          <span class="font-medium text-gray-900">
            {{ item.paymentStatus === partiallyRefunded ? partiallyRefundedLabel : statusLabels[item.status] }}
          </span>
        </div>

        <div *ngIf="item.receiptUrl" class="flex justify-between gap-4">
          <span class="text-gray-600">{{ config.receipt }}</span>
          <a
            class="font-medium text-primary-700 hover:underline flex items-center gap-1"
            [href]="item.receiptUrl"
            target="_blank"
            rel="noopener"
          >
            <vs-icon name="download-01" size="14"></vs-icon>
            {{ config.downloadPdf }}
          </a>
        </div>
      </div>

      <div class="flex items-end justify-between gap-4 px-4 py-3 border-t border-gray-200">
        <span class="text-sm font-medium text-gray-700">
          {{ config.total }} · {{ item.warrantyCount }} {{ item.warrantyCount === 1 ? config.warrantySingular :
          config.warrantyPlural }}
        </span>
        <span class="text-2xl font-semibold leading-none text-gray-900">
          {{ item.totalAmount / 100 | currency: 'USD' : 'symbol' : '1.2-2' }}
        </span>
      </div>
    </div>

    <div *ngIf="error" class="flex flex-row gap-2 bg-danger-50 bg-opacity-50 border border-danger-300 rounded-lg p-3">
      <vs-icon name="alert-triangle" size="16" class="text-danger-700 shrink-0"></vs-icon>
      <p class="text-danger-700 text-sm">{{ config.loadError }}</p>
    </div>

    <ng-container *ngIf="!error">
      <div *ngIf="warranties === null" class="rounded-xl overflow-hidden border border-gray-200">
        <vs-table-skeleton [rows]="skeletonRows" [columns]="4" [showHeader]="true" [banding]="true"></vs-table-skeleton>
      </div>

      <ng-container *ngIf="warranties as warranties">
        <!-- Large batches scroll inside the dialog -->
        <div *ngIf="warranties.length" class="rounded-xl border border-gray-200 max-h-[45vh] overflow-y-auto">
          <vs-table [columns]="columns" [data]="warranties"></vs-table>
        </div>

        <!-- Cancelled and expired batches release their warranties, so no rows is expected here. -->
        <p *ngIf="!warranties.length" class="text-sm text-gray-600 text-center py-4">{{ config.releasedNote }}</p>
      </ng-container>
    </ng-container>

    <div
      class="sticky bottom-0 z-10 -mx-2 -mb-1 px-2 pt-3 pb-3 bg-base border-t border-gray-200 flex items-center justify-end"
    >
      <button vs-button theme="primary" class="min-w-[120px] justify-center" (click)="close()">
        {{ config.done }}
      </button>
    </div>
  </div>
</vs-dialog>
